(function () {
    ('use strict');
    ('ngInject');

    angular.module('app.ctrls').controller('StampCtrl', stampCtrl);

    function stampCtrl($scope, $routeParams, $window, $cookies) {
        const { stampId, gclid, redirectTo } = $routeParams;
        const expiryDate = new Date();
        expiryDate.setFullYear(expiryDate.getFullYear() + 10);

        const cookieOptions = {
            domain: process.env.VUE_APP_STAMP_COOKIE_DOMAIN,
            expires: expiryDate.toUTCString(),
            secure: process.env.NODE_ENV !== 'development'
        };

        if (stampId) {
            const existingStamp = $cookies.get('customilyStamp');
            const newStamp = existingStamp ? `${existingStamp}-${stampId}` : stampId;
            $cookies.put('customilyStamp', newStamp, cookieOptions);
        }

        if (gclid) {
            $cookies.put('customilyGclid', gclid, cookieOptions);
        }

        setTimeout(function () {
            //timeout to leave enough time for GTM execution
            if (redirectTo) {
                const baseURL = process.env.VUE_APP_CUSTOMILY_BASE_URL;
                $window.location.href = `${baseURL}/signup?storeType=${redirectTo}`;
            } else {
                //added window.location.search to keep GTM query params
                $window.location.href = `https://apps.shopify.com/customily-product-personalizer${window.location.search}`;
            }
        }, 500);
    }
})();
